const Alerts = {
  baseStyle: {
    container: {
      padding: "1em",
      borderRadius: "0.5em",
    },
  },
  variants: {
    standard: {
      container: {
        mt: "0.5em",
        mb: "0.5em",
        padding: "0.5em",
        borderRadius: "0.5em",
        bg: "Alert",
        color: "black",
        justifyContent: "center",
        alignItems: "center",
      },
    },
  },
}

export default Alerts
